import styled, { CSSProperties } from 'styled-components';

import { WIDTH_PHONE } from '~src/util';

export const ContainerLeft = styled.div({
  width: `calc(100% - 280px)`,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const ContainerRight = styled.div({
  flex: '0 0 280px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '0 0 0 20px',
});

export const styledSavingsWidget: CSSProperties = {
  position: 'sticky',
  top: '110px',

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  [`@media (maxWidth: ${WIDTH_PHONE}px)`]: {
    position: 'unset',
    top: 'unset',
  },
};
